import React from 'react';
import withIcon from '../utilities/withIcon';

const IconCamera = () => {
  return (
    <g>
      <path d="m15.2065 3.4824h-3.7486l-.6005-2.084a.7008.7008 0 0 0 -.6728-.5068h-4.37a.7008.7008 0 0 0 -.6729.5068l-.6 2.084h-3.7482a.7.7 0 0 0 -.7.7v10.2258a.7.7 0 0 0 .7.7h14.413a.7.7 0 0 0 .7-.7v-10.2256a.7.7 0 0 0 -.7-.7002zm-8.8647-1.1904h3.3159l.3433 1.19h-4.002zm8.1645 11.416h-13.0126v-8.8252h13.0127z" />
      <path d="m8 5.6846a3.61 3.61 0 1 0 3.61 3.61 3.6148 3.6148 0 0 0 -3.61-3.61zm0 5.82a2.21 2.21 0 1 1 2.21-2.21 2.2122 2.2122 0 0 1 -2.21 2.2103z" />
    </g>
  );
};

export default withIcon(IconCamera);
